import React, { useState } from "react";

const Accreditation = () => {
  const [showFullAccreditation, setShowFullAccreditation] = useState(false);
  const [showFullMandate, setShowFullMandate] = useState(false);

  const toggleAccreditation = () => setShowFullAccreditation(!showFullAccreditation);
  const toggleMandate = () => setShowFullMandate(!showFullMandate);

  return (
    <div className="py-20 px-6 md:px-20 lg:px-32 bg-gray-50">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        {/* === Mandate Section === */}
        <section id="mandate">
          <div className="bg-white shadow-md hover:shadow-lg transition-shadow duration-300 rounded-2xl p-8 border border-gray-100">
            <h2 className="text-3xl font-bold text-gray-700 mb-4 flex items-center gap-2">
              <span className="text-red-500">📜</span> Mandate
            </h2>

            <p className="text-gray-700 leading-relaxed">
              {showFullMandate ? (
                <>
                  Strengthen government’s control and regulation of schools below tertiary level in the State, through the standardization, monitoring and evaluation of both private and public schools.
                  <br /><br />
                  Maintain appropriate policies, guidelines and instruments for Quality Assurance Evaluation in the State.
                  <br /><br />
                  Registration, Documentation and Approval of all private institutions below tertiary level in the State.
                  <br /><br />
                  Demand and obtain relevant data and reports on matters relating to Quality Assurance from all parastatals and schools.
                  <br /><br />
                  Ensure quality and professionalism in the recruitment, training, placement and promotion of teachers.
                  <br /><br />
                  Develop a state-wide and harmonized school calendar in collaboration with stakeholders.
                  <br /><br />
                  Establish a database of private institutions below tertiary level in the State, including all reports of assessment, approval, and grading.
                  <br /><br />
                  Conduct Quality Assurance Evaluation of Public and Private Education Institutions, including review and amendment of the school curriculum in collaboration with stakeholders.
                  <br /><br />
                  Accredit Schools for External Examinations.
                  <br /><br />
                  Produce Annual State of Education Report.
                  <br /><br />
                  Rank private schools and publish results in print and electronic media.
                  <br /><br />
                  Investigate all matters affecting learners, parents, staff, and school management.
                  <br /><br />
                  Ensure that every child is enrolled in school and receives qualitative education through collaboration with other stakeholders.
                  <br /><br />
                  Organize special programmes and social awareness activities for academic, social, and moral development.
                  <br /><br />
                  Produce and review Guidelines on the Establishment of Private Institutions.
                  <br /><br />
                  Monitor internal and external examinations.
                  <br /><br />
                  Liaise with relevant agencies to ensure school environments are conducive and have adequate facilities for learning.
                  <button
                    onClick={toggleMandate}
                    className="mt-6 block text-blue-600 font-medium hover:text-blue-800 transition"
                  >
                    ← Read Less
                  </button>
                </>
              ) : (
                <>
                  Strengthen government’s control and regulation of schools below tertiary level in the State, through the standardization, monitoring and evaluation of both private and public schools...
                  <button
                    onClick={toggleMandate}
                    className="mt-4 block text-blue-600 font-medium hover:text-blue-800 transition"
                  >
                    Read More →
                  </button>
                </>
              )}
            </p>
          </div>
        </section>

        {/* === Accreditation Section === */}
        <section id="accreditation">
          <div className="bg-white shadow-md hover:shadow-lg transition-shadow duration-300 rounded-2xl p-8 border border-gray-100">
            <h2 className="text-3xl font-bold text-gray-700 mb-4 flex items-center gap-2">
              <span className="text-green-600">✅</span> Accreditation
            </h2>

            <p className="text-gray-700 leading-relaxed">
              {showFullAccreditation ? (
                <>
                  To get accredited, public/private primary or secondary schools must provide necessary documents such as:
                  <ul className="mt-4 list-disc list-inside space-y-2 text-gray-700">
                    <li>School policies and procedures (admissions, discipline, health & safety, etc.).</li>
                    <li>Curriculum details — including scope, course syllabi, and supporting materials.</li>
                    <li>Staff credentials and qualifications — degrees, certifications, and licenses.</li>
                    <li>Facilities and resources — classrooms, libraries, laboratories, and sports facilities.</li>
                    <li>Financial statements — income and expenditure reports, balance sheets, and audits.</li>
                    <li>Student records — enrollment data, attendance, and academic transcripts.</li>
                  </ul>

                  <p className="mt-4">
                    <strong>Site Visit & Inspection:</strong> After documentation, an accreditation team may conduct a site visit to assess curriculum implementation, facilities, and teaching quality.
                  </p>

                  <p className="mt-4">
                    <strong>Evaluation & Review:</strong> After inspection, the accreditation body evaluates all documents and determines compliance with required standards.
                  </p>

                  <button
                    onClick={toggleAccreditation}
                    className="mt-6 block text-blue-600 font-medium hover:text-blue-800 transition"
                  >
                    ← Read Less
                  </button>
                </>
              ) : (
                <>
                  To get accredited, public/private primary or secondary schools must provide necessary documents such as school policies, curriculum details, and staff qualifications...
                  <button
                    onClick={toggleAccreditation}
                    className="mt-4 block text-blue-600 font-medium hover:text-blue-800 transition"
                  >
                    Read More →
                  </button>
                </>
              )}
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Accreditation;
